import { partesDoBloco } from "@/modules/escala/format";

interface BlocoDataProps {
  iso: string;
  /** "ativa" = destaque da marca; "apagada" = escala realizada ou cancelada. */
  estado?: "ativa" | "apagada";
}

/** Bloco de data "OUT / 04 / DOM" à esquerda dos cards. Decorativo: a data completa já está no texto do card. */
export function BlocoData({ iso, estado = "ativa" }: BlocoDataProps) {
  const { mes, dia, semana } = partesDoBloco(iso);
  const ativa = estado === "ativa";
  return (
    <span
      aria-hidden
      className={`flex w-[54px] shrink-0 flex-col items-center justify-center gap-[3px] rounded-xl py-1.5 leading-none ${
        ativa ? "bg-primary/[0.16] dark:bg-primary/[0.22]" : "bg-surface-2"
      }`}
    >
      <span className={`text-[10px] font-extrabold uppercase tracking-wider ${ativa ? "text-text/80" : "text-muted"}`}>
        {mes}
      </span>
      <span className={`text-[22px] font-extrabold ${ativa ? "text-text" : "text-muted"}`}>{dia}</span>
      <span className={`text-[10px] font-semibold uppercase tracking-wide ${ativa ? "text-text/80" : "text-muted"}`}>
        {semana}
      </span>
    </span>
  );
}
